<template>

    <div class="layout__container">
        <!--<div class="layout__padding-clear layout__width-90" v-show="activeForm === 'login'">-->
        <div class="layout__padding-clear layout__width-90">
            <div class="layout__padding-clear layout__width-90">
                <el-radio-group v-model="activeForm" :max="1" class="layout__padding-clear layout__width-100 rifat">
                    <el-radio-button class="component__forms-2" label="login" :key="'login'">Login
                    </el-radio-button>
                    <el-radio-button class="component__forms-2" label="register" :key="'register'">Register
                    </el-radio-button>
                </el-radio-group>
            </div>

            <div class="layout__padding-clear layout__padding-20px" v-show="activeForm === 'login'">
                <div class="text__size-14 text__align-center">Welcome back to Ravensworth, please login below</div>
                <div class="layout__padding__top-25px">

                    <el-form :model="login" status-icon ref="login" :rules="rules" class="layout__padding-clear"
                             :disabled="available_branches.length > 1">
                        <el-form-item prop="username">
                            <div class="layout__padding-5-0">Username</div>
                            <el-input class=" layout__padding-5-0 layout__position-right" placeholder="username"
                                      v-model="login.username" clearable autofocus></el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <div class="layout__padding-5-0">Password</div>
                            <el-input class=" layout__padding-5-0 layout__position-right" placeholder="password"
                                      type=password v-model="login.password" clearable></el-input>
                        </el-form-item>

                        <div class="layout__padding-20px">
                            <el-button
                                    class="button-red button__base layout__position-center layout__width-200px"
                                    v-on:click="validateLogin('login')">LOGIN
                            </el-button>
                            <!--<div class="layout__width-250px layout__padding-clear">-->
                            <!--<a v-bind:href="forgotPassword" target="_top">-->
                            <div class="text__colour-light-teal text__size-12 text__align-center layout__padding__top-20px layout__cursor-pointer"
                                 v-on:click="activePanel = 'forgot'">
                                Forgotten login details?
                            </div>
                            <!--</a>-->
                            <!--</div>-->
                            <div id="error">
                                <p class="component__message-base component__message-fail">We cannot match that username
                                    and password. Please check and try again.</p>
                            </div>
                            <div id="firstTimeUser">
                                <p class="component__message-base component__message-fail">We've sent a secure password
                                    to the email address
                                    to validate the account for first time login
                                </p>
                            </div>
                        </div>
                    </el-form>
                </div>
            </div>

            <div class="layout__padding-clear layout__padding-20px" v-show="activePanel === 'login'"
                 v-if="available_branches.length > 1">
                <div class="text__size-14 text__align-center">Please choose which branch you would like to order on behalf of</div>
                <div class="layout__padding__top-25px">
                    <el-table
                            :data="available_branches.filter(data => !search || data.customerBranchName.toLowerCase().includes(search.toLowerCase()) || data.customerRef.toLowerCase().includes(search.toLowerCase()))"
                            style="width: 100%"
                            ref="singleTable"
                            highlight-current-row
                            @current-change="handleCurrentChange"
                            border-bottom>
                        <el-table-column
                                label="Branch Name"
                                prop="customerBranchName">
                        </el-table-column>
                        <el-table-column
                                label="Branch Ref"
                                prop="customerRef">
                        </el-table-column>
                        <el-table-column
                                label="Branch Status"
                                prop="customerStatus">
                        </el-table-column>
                        <el-table-column
                                align="right">
                            <template slot="header" slot-scope="scope">
                                <el-input
                                        v-model="search"
                                        size="medium"
                                        placeholder="Search"/>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--<el-radio-group v-for="(branch) in available_braches" v-model="selected_branch"-->
                                    <!--class="layout__width-400px">-->
                        <!--<el-radio-button :key="branch.customerRef" :label="branch.customerRef"-->
                                  <!--class="layout__width-300px text__align-left">-->
                            <!--<div class="layout__width-400px text__align-left">-->
                                <!--{{branch.customerBranchName}} | {{branch.customerRef}} |{{branch.customerStatus}}-->
                            <!--</div>-->
                        <!--</el-radio-button>-->
                    <!--</el-radio-group>-->


                    <div class="layout__padding-20px">
                        <el-button
                                class="button-red button__base layout__position-center layout__width-200px"
                                v-on:click="multiBranchLogin">LOGIN WITH BRANCH
                        </el-button>
                    </div>

                </div>
            </div>

            <div class="layout__padding-clear layout__padding-20px"
                 v-show="activePanel === 'register'">
                <div class="text__size-14 text__align-center">If this is your first visit, please register to access our
                    online services
                </div>
                <div class="layout__padding__top-25px">
                    <el-form :model="registration" status-icon :rules="rules" ref="registration">
                        <!--<div class="component__forms-2">-->
                        <el-form-item prop="forename">
                            <div class="layout__padding-5-0">Forename</div>
                            <el-input class="" placeholder="forename"
                                      v-model="registration.forename" clearable autofocus></el-input>
                        </el-form-item>
                        <el-form-item prop="surname">
                            <div class="layout__padding-5-0">Surname</div>
                            <el-input class="" placeholder="surname"
                                      v-model="registration.surname" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="company">
                            <div class="layout__padding-5-0">Company</div>
                            <el-input class="" placeholder="company"
                                      v-model="registration.company" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="telephone">
                            <div class="layout__padding-5-0">Telephone</div>
                            <el-input class="" placeholder="telephone"
                                      v-model="registration.telephone" clearable></el-input>
                        </el-form-item>
                        <!--<div class="">-->
                        <!--<el-checkbox v-model="registration.subscribed"><p class="">Keep me informed of new offers</p></el-checkbox>-->
                        <!--</div>-->
                        <!--</div>-->
                        <!--<div class="component__forms-2">-->
                        <el-form-item prop="postcode">
                            <div class="layout__padding-5-0">Postcode</div>
                            <el-input class="" placeholder="postcode"
                                      v-model="registration.postcode" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="email">
                            <div class="layout__padding-5-0">Email</div>
                            <el-input class="" placeholder="email"
                                      v-model="registration.email"
                                      clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <div class="layout__padding-5-0">Password</div>
                            <el-input class="paddingPassword" type="password"
                                      placeholder="password" v-model="registration.password"
                                      clearable></el-input>
                        </el-form-item>
                        <!--{{registration.subscribed}}-->
                        <el-form-item>
                            <div class="">
                                <el-checkbox v-model="registration.subscribed" class=""><p class="">Keep me informed of
                                    exclusive news and offers</p></el-checkbox>
                            </div>
                        </el-form-item>

                        <div class="layout__padding-clear" v-show="showRecaptcha === true">
                            <vue-recaptcha
                                    ref="recaptcha"
                                    class="layout__padding-20-0"
                                    @verify="onVerify"
                                    @expired="onExpired"
                                    :sitekey="'6Lfg2qIUAAAAADKlBXuXz-tPxFAheAyPTQoevfUk'">
                            </vue-recaptcha>
                        </div>
                        <div class="layout__padding-clear">
                            <div id="invalidRegister" class="layout__position-center">
                                <p class="component__message-base component__message-fail">There was a problem
                                    registering
                                    your account. Please try
                                    again</p>
                            </div>
                            <div id="dupRegister" class="layout__position-center">
                                <p class="component__message-base component__message-fail">Email address already
                                    registered.
                                    Login or Reset
                                    password to continue</p>
                            </div>
                            <div class="layout__padding-clear">
                                <el-button class="button-red button__base layout__position-center layout__width-200px"
                                           :disabled="recaptchaNotComplete"
                                           v-on:click="submitForm('registration')">REGISTER
                                </el-button>
                                <!--:disabled="recaptchaNotComplete"-->
                            </div>

                            <div class="text__size-10 layout__padding__top-20px">

                                <div>By signing up you will be able to pay for orders using a credit or debit card</div>
                                <div>If you would like to set up a credit account* and be billed monthly please email
                                    <br><a
                                            href="mailto:customer.services@ravensworth.co.uk" class="link__colour-teal"
                                            target="_top">client.support@ravensworth.co.uk</a></div>
                                By signing up you agree to our <a href="https://ravensworth.co.uk/terms-and-conditions/"
                                                                  class="link__colour-teal" target="_top">Terms and
                                Conditions</a> and <a
                                    href="https://ravensworth.co.uk/privacy-policy/" class="link__colour-teal"
                                    target="_top">Privacy
                                Policy</a>
                                <div>
                                    *Subject to standard credit checks, credit accounts can take up to 48 hours to set
                                    up. This option
                                    will automatically appear in your checkout options once approved.
                                </div>

                            </div>
                        </div>
                    </el-form>
                </div>
            </div>

            <div class="layout__padding-clear layout__padding-20px"
                 v-show="activePanel === 'forgot'">

                <h3 class="text__align-center text__colour-teal">Forgotten Password</h3>
                <div class="text__size-14 text__align-center layout__padding-20-0">Please enter your registered email
                    address in the field below to receive a password reset link by email
                </div>
                <div class="">
                    <el-form :model="reset" status-icon ref="reset" :rules="rules" class="layout__padding-clear">
                        <el-form-item prop="resetEmail">
                            <div class="layout__padding-5-0">Registered Email Address <span
                                    class="text__colour-red">*</span></div>
                            <el-input class=""
                                      placeholder="Email Address"
                                      v-model="reset.resetEmail" clearable
                                      autofocus></el-input>
                        </el-form-item>
                        <div class="layout__margin-20-0">
                            <el-button
                                    class="button-red button__base layout__position-center layout__width-200px"
                                    v-on:click="sendResetLink('reset')">
                                SUBMIT
                            </el-button>
                        </div>
                        <p class="text__size-12 text__align-center">You should receive an email within the next 15
                            mins</p>
                    </el-form>
                </div>
            </div>

        </div>

        <div class="layout__padding-clear layout__width-90" v-show="activeForm === 'register'">
            <div class="text__colour-teal text__style-bold text__align-center layout__margin__bottom-25px text__size-22">Register with us today</div>

<!--            <div class="text__colour-teal text__size-15 text__style-bold text__align-center layout__margin__bottom-10">To create your account,</div>-->
<!--            <div class="text__colour-teal text__size-15 text__style-bold text__align-center layout__margin__bottom-20">Please choose from one of the options below:</div>-->

            <div class="text__align-center">
                <el-button id="accountOptionsDialog" class="button__base button__background-tickled-pink text__align-center layout__cursor-pointer layout__margin__bottom-20 layout__width-400px text__line-height-13 text__size-16-important"
                        v-on:click="createAccount('ACCOUNT', 'MONTHLYEMAILINVOICE')">Register here</el-button>
            </div>

<!--            <div class="text__align-center">-->
<!--                <el-button id="accountOptionsDialog" class="button__base button__background-tickled-pink text__align-center layout__cursor-pointer layout__margin__bottom-40 layout__width-400px text__line-height-13 text__size-16-important"-->
<!--                        v-on:click="createAccount('PAYG', 'PAYGEMAILINVOICE')">PAYG account <br> to pay via credit or debit card</el-button>-->
<!--            </div>-->

<!--            <div class="text__colour-teal text__size-15 text__align-center layout__margin__bottom-10">-->
<!--              Create an account on MyRavensworth and choose from monthly invoices <br>-->
<!--              or pay as you go with a card.*-->
<!--            </div>-->
            <div class="text__colour-teal text__size-15 text__align-center layout__margin__bottom-10">
              MyRavensworth is a central marketing hub, home to our online services: <br>
              Instant Print, Directmailr™ and Photofixr™.
            </div>

<!--            <div class="text__colour-teal text__size-15 text__align-center layout__margin__bottom-10">*Please note that a PAYG account only gives you access to Photofixr,</div>-->
<!--            <div class="text__colour-teal text__size-15 text__align-center layout__margin__bottom-10">Instant Print and Directmailr require users to have a credit account</div>-->
        </div>

    </div>

</template>

<script>
    import Axios from 'axios';
    import Router from '../router';
    import EventBus from '../EventBus.js';
    import {axios} from '@/mixins/Axios.js';
    import {Loading} from 'element-ui';
    import VueRecaptcha from 'vue-recaptcha';

    export default {
        name: "login",
        mixins: [axios],
        props: {},
        components: {
            VueRecaptcha
        },
        data() {
            const emailValidation = (rule, value, callback) => {

                const regexEmail = /^(([^<>()\[\]\\.,;:!\s@"]+(\.[^<>()\[\]\\.,;:!\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                if (!regexEmail.test(value)) {
                    callback(new Error('Incorrect Email Format'));
                } else {
                    callback(); // this loops back to the calling method
                }
            };
            const confirmEmailValidation = (rule, value, callback) => {
                if (this.registration.email != this.registration.confirm_email) {
                    callback(new Error('Confirmation email does not match email entered'));
                } else {
                    callback();
                }
            };
            const confirmPasswordValidation = (rule, value, callback) => {
                if (this.registration.password != this.registration.confirm_password) {
                    callback(new Error('Confirmation password does not match password entered'));
                } else {
                    callback();
                }
            };
            const postcodeValidation = (rule, value, callback) => {

                const regexPostcode = /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})/;

                if (!regexPostcode.test(value)) {
                    callback(new Error('Incorrect Postcode Format'));
                } else {
                    callback(); // this loops back to the calling method
                }
            };
            const numberValidation = (rule, value, callback) => {

                const regexPostcode = /^[0-9]+$/;

                if (!regexPostcode.test(value)) {
                    callback(new Error('Incorrect Telephone Format'));
                } else {
                    callback(); // this loops back to the calling method
                }
            };
            return {
                login: {
                    username: '',
                    password: ''
                },
                registration: {
                    forename: '',
                    surname: '',
                    company: '',
                    postcode: '',
                    telephone: '',
                    email: '',
                    confirm_email: '',
                    password: '',
                    confirm_password: '',
                    subscribed: false,
                    invalidMessage: '',
                },
                available_branches: [],
                selected_branch: '',
                current_branch: '',
                search: '',
                recaptchaNotComplete: true,
                showRecaptcha: true,
                reset: {
                    resetEmail: ''
                },
                forgotPassword: `/forgot-password`,
                invalidFlag: false,
                activeForm: '',
                activePanel: '',
                accountOptionsDialog: false,
                rules: {
                    username: [
                        {
                            required: true,
                            message: 'Username/Email Address required',
                            trigger: 'blur'
                        },
                    ],
                    password: [
                        {
                            required: true,
                            message: 'Password required',
                            trigger: 'blur'
                        },
                    ],
                    forename: [{
                        required: true, message: 'Forename required', trigger: 'blur'
                    }],
                    surname: [{
                        required: true, message: 'Surname required', trigger: 'blur'
                    }],
                    company: [{
                        required: true, message: 'Company required', trigger: 'blur'
                    }],
                    postcode: [
                        {
                            required: true, message: 'Postcode required', trigger: 'blur'
                        },
                        {
                            validator: postcodeValidation
                        }
                    ],
                    telephone: [{
                        required: true, message: 'Telephone required', trigger: 'blur'
                    },
                        {
                            validator: numberValidation
                        }
                    ],
                    email: [
                        {
                            required: true, message: 'Email Address required', trigger: 'blur'
                        },
                        {
                            validator: emailValidation
                        }
                    ],
                    confirm_email: [
                        {
                            required: true,
                            message: 'Email Address Confirmation required - should match email address entered above',
                            trigger: 'blur'
                        },
                        {
                            validator: confirmEmailValidation
                        }
                    ],
                    password: [{
                        required: true, message: 'Password required', trigger: 'blur'
                    }],
                    confirm_password: [
                        {
                            required: true,
                            message: 'Password Confirmation required - should match password entered above',
                            trigger: 'blur'
                        },
                        {
                            validator: confirmPasswordValidation
                        }
                    ],
                    resetEmail: [{
                        required: true, message: 'required registered email address', trigger: 'blur'
                    }]
                }
            }
        },
        // computed: {
        //     userContext() {
        //         return this.returnAllCookies()
        //     }
        // },
        beforeMount() {
            this.activeForm = 'login'
            this.activePanel = 'login'

            console.log(this.returnCookie("_token"))
            if (typeof this.returnCookie("_token") === 'undefined') {
                const url = '/.auth/me'
                console.log(url)
                Axios.get(url, {withCredentials: true})
                    .then(response => {
                        console.log(response)

                        // const accessToken = response.data[0].id_token;
                        // window.sessionStorage.setItem('_token', accessToken)
                        console.log(response.data[0].id_token)

                        const internalAuth = {
                            idToken: response.data[0].id_token
                        }

                        const internalAuthUrl = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/TokenAuth/InternalAuthenticate`

                        console.log(internalAuth)
                        console.log(internalAuthUrl)

                        Axios.post(internalAuthUrl, internalAuth, this.returnHeaderNoToken)
                            .then(response => {
                                console.log(response)
                                const accessToken = response.data.result.accessToken

                                const getCurrentLoginContext = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Session/GetCurrentLoginContext`

                                Axios.get(getCurrentLoginContext, this.returnHeaderUsingParameter(accessToken))
                                    .then(response => {
                                        this.persistUserSessionUsingParameter(accessToken, response)

                                        // this.$nextTick(() => { // Loading should be closed asynchronously
                                        //     loadingInstance.close();
                                        // });
                                        this.resetAndCloseDialog()
                                    })
                                    .catch(error => {

                                        if (error.response.status === 500) {
                                            document.getElementById('error').style.display = 'block';
                                        }
                                        // this.$nextTick(() => { // Loading should be closed asynchronously
                                        //     loadingInstance.close();
                                        // });
                                        event.stopPropagation();
                                    });
                            })
                    })
                    .catch(error => {
                        console.log(typeof error)
                        if (typeof error.response === 'undefined' || error.response.status === 500) {
                            console.log('error')
                        }
                    });
            }
        },
        mounted() {
            this.activePanel = 'login'
            document.getElementById('error').style.display = "none";
            document.getElementById('firstTimeUser').style.display = "none";
            document.getElementById('invalidRegister').style.display = "none";
            document.getElementById('dupRegister').style.display = "none";

            if (`${process.env.VUE_APP_ENVIRONMENT}` === 'dev') {
                this.showRecaptcha = false;
                this.recaptchaNotComplete = false;
            }
        },
        beforeDestroy() {
            this.activePanel = 'login'
            this.resetObjects();
        },
        methods: {
            validateLogin(login) {
                this.$refs[login].validate((valid) => {
                    if (valid) {
                        const url = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/TokenAuth/Authenticate`

                        const loginCredentials = {
                            "userNameOrEmailAddress": this.login.username,
                            "password": this.login.password,
                            "rememberClient": true
                        }

                        let loadingInstance = Loading.service({
                            fullscreen: true
                        });

                        Axios.post(url, loginCredentials, this.returnHeaderNoToken())
                            .then(response => {
                                console.log(response)
                                // if else if token is empty


                                if (typeof response.data.result === 'undefined') {

                                    // todo throw an error message

                                    console.log('first time user - william user')
                                    document.getElementById('firstTimeUser').style.display = 'block';

                                    this.$nextTick(() => { // Loading should be closed asynchronously
                                        loadingInstance.close();
                                    });

                                } else {

                                    console.log('change password required')
                                    console.log(response.data.result.passwordChangeRequired)

                                    if (typeof response.data.result.passwordChangeRequired !== 'undefined' && response.data.result.passwordChangeRequired) {
                                        console.log('setting the reset boolean')
                                        window.sessionStorage.setItem("_passwordChangeRequired", true.toString())

                                    }

                                    const accessToken = response.data.result.accessToken;
                                    const getCurrentLoginContext = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Session/GetCurrentLoginContext`

                                    console.log('getLoginContext', getCurrentLoginContext)

                                    Axios.get(getCurrentLoginContext, this.returnHeaderUsingParameter(accessToken))
                                        .then(response => {

                                            console.log(response.data.result)


                                            console.log(response.data.result.session.membershipCount)

                                            console.log(response.data.result.session.membershipCount <= 1)


                                            if (typeof response.data.result.customer !== 'undefined') {

                                                window.sessionStorage.setItem("_membershipCount", '1')
                                                this.persistUserSessionUsingParameter(accessToken, response)
                                                this.resetAndCloseDialog()

                                            } else if (response.data.result.session.membershipCount <= 1) {

                                                window.sessionStorage.setItem("_membershipCount", '1')
                                                this.persistUserSessionUsingParameter(accessToken, response)
                                                this.resetAndCloseDialog()

                                            } else {

                                                window.sessionStorage.setItem("_membershipCount", response.data.result.session.membershipCount)
                                                const url = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Customer/GetCustomerMemberships?userId=` + response.data.result.user.id

                                                Axios.get(url, this.returnHeaderUsingParameter(accessToken))
                                                    .then(response => {
                                                        console.log(response)
                                                        this.available_branches = response.data.result
                                                    })

                                            }

                                            this.$nextTick(() => { // Loading should be closed asynchronously
                                                loadingInstance.close();
                                            });

                                            // todo might need to land in a better place for the admin users but not a huge priority

                                            // if (this.noRouting == 'false') {
                                            //
                                            //     if (this.returnCookie("_role") === 'Customer') {
                                            //         Router.push({
                                            //             name: '/account/summary'
                                            //         })
                                            //     } else {
                                            //         Router.push({
                                            //             name: '/admin/summary'
                                            //         })
                                            //     }
                                            // } else {
                                            // this.resetAndCloseDialog()

                                            // }
                                        })
                                        .catch(error => {

                                            console.log(error)

                                            if (error.response.status === 500) {
                                                document.getElementById('error').style.display = 'block';
                                            }
                                            this.$nextTick(() => { // Loading should be closed asynchronously
                                                loadingInstance.close();
                                            });
                                            event.stopPropagation();

                                            this.resetAndCloseDialog()

                                        });
                                }
                            })
                            .catch(error => {

                                console.log(error)


                                if (error.response.status === 500) {
                                    document.getElementById('error').style.display = 'block';
                                }
                                this.$nextTick(() => { // Loading should be closed asynchronously
                                    loadingInstance.close();
                                });
                                event.stopPropagation();
                            });
                    } else {
                        return false;
                    }
                })
            },
            multiBranchLogin() {

                const url = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/TokenAuth/Authenticate`

                const loginCredentials = {
                    "userNameOrEmailAddress": this.login.username,
                    "password": this.login.password,
                    "customerRef": this.selected_branch.customerRef,
                    "rememberClient": true
                }

                let loadingInstance = Loading.service({
                    fullscreen: true
                });

                Axios.post(url, loginCredentials, this.returnHeaderNoToken())
                    .then(response => {
                        console.log(response)
                        // if else if token is empty


                        if (typeof response.data.result === 'undefined') {

                            // todo throw an error message

                            console.log('first time user - william user')
                            document.getElementById('firstTimeUser').style.display = 'block';

                            this.$nextTick(() => { // Loading should be closed asynchronously
                                loadingInstance.close();
                            });

                        } else {

                            console.log('change password required')
                            console.log(response.data.result.passwordChangeRequired)

                            if (typeof response.data.result.passwordChangeRequired !== 'undefined' && response.data.result.passwordChangeRequired) {
                                console.log('setting the reset boolean')
                                window.sessionStorage.setItem("_passwordChangeRequired", true.toString())

                            }

                            const accessToken = response.data.result.accessToken;
                            const getCurrentLoginContext = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Session/GetCurrentLoginContext`

                            console.log('getLoginContext', getCurrentLoginContext)

                            Axios.get(getCurrentLoginContext, this.returnHeaderUsingParameter(accessToken))
                                .then(response => {


                                    if (response.data.result.customer) {
                                        this.persistUserSessionUsingParameter(accessToken, response)
                                    } else {

                                    }

                                    this.$nextTick(() => { // Loading should be closed asynchronously
                                        loadingInstance.close();
                                    });

                                    this.resetAndCloseDialog()
                                })
                                .catch(error => {

                                    console.log(error)

                                    if (error.response.status === 500) {
                                        document.getElementById('error').style.display = 'block';
                                    }
                                    this.$nextTick(() => { // Loading should be closed asynchronously
                                        loadingInstance.close();
                                    });
                                    event.stopPropagation();

                                    this.resetAndCloseDialog()

                                });
                        }
                    })
                    .catch(error => {

                        console.log(error)


                        if (error.response.status === 500) {
                            document.getElementById('error').style.display = 'block';
                        }
                        this.$nextTick(() => { // Loading should be closed asynchronously
                            loadingInstance.close();
                        });
                        event.stopPropagation();
                    });
            },
            //login() {
            //    document.getElementById('login').click()
            //},
            resetForm(registration) {
                this.$refs[registration].resetFields();
            },
            submitForm(registration) {

                this.$refs[registration].validate((valid) => {
                    if (valid) {

                        const registerUrl = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Account/Register`

                        console.log(registerUrl)

                        const registrationDetails = {
                            "name": this.registration.forename,
                            "surname": this.registration.surname,
                            "companyName": this.registration.company,
                            "postcode": this.registration.postcode,
                            "phoneNumber": this.registration.telephone,
                            "emailAddress": this.registration.email,
                            "password": this.registration.password,
                            "userName": this.registration.email,
                            "subscribed": this.subscribed

                        }

                        let loadingInstance = Loading.service({
                            fullscreen: true
                        });

                        console.log('register json!' + registrationDetails.password + '!')

                        Axios.post(registerUrl, registrationDetails, this.returnHeaderNoToken())
                            .then(response => {

                                console.log(response)

                                // with the response from the register
                                // do the call to the login endpoint - with the details from above

                                // then do a call to checkout page - do a test to see if we wait how long it will be before we move pages


                                const url = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/TokenAuth/Authenticate`

                                const loginCredentials = {
                                    "userNameOrEmailAddress": this.registration.email,
                                    "password": this.registration.password,
                                    "rememberClient": true
                                }

                                console.log(loginCredentials)

                                Axios.post(url, loginCredentials, this.returnHeaderNoToken())
                                    .then(response => {
                                        console.log(response)


                                        const accessToken = response.data.result.accessToken;
                                        const getCurrentLoginContext = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Session/GetCurrentLoginContext`

                                        console.log('getLoginContext', getCurrentLoginContext)

                                        Axios.get(getCurrentLoginContext, this.returnHeaderUsingParameter(accessToken))
                                            .then(response => {
                                                this.persistUserSessionUsingParameter(accessToken, response)

                                                // EventBus.$emit('update', this.returnAllCookies())

                                                this.$nextTick(() => { // Loading should be closed asynchronously
                                                    loadingInstance.close();
                                                });
                                                this.resetAndCloseDialog()

                                            })
                                    });
                            })
                            .catch(error => {
                                if (error.response.status === 500) {
                                    // this.invalidMessage = "There was a problem registering your account please try again"
                                    document.getElementById('invalidRegister').style.display = 'block';
                                }
                                if (error.response.status === 400) {
                                    document.getElementById('dupRegister').style.display = 'block';
                                }

                                console.log('before close after error caught')
                                this.$nextTick(() => { // Loading should be closed asynchronously
                                    loadingInstance.close();
                                });
                                event.stopPropagation();
                            });

                    } else {
                        return false;
                    }
                })

            },
            sendResetLink(reset) {
                this.$refs[reset].validate((valid) => {
                    if (valid) {

                        const forogttenPassword = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/TokenAuth/ForgotPassword`

                        const forgotPasswordBody = {
                            "userNameOrEmailAddress": this.reset.resetEmail
                        }

                        Axios.post(forogttenPassword, forgotPasswordBody, this.returnHeaderNoToken())
                            .then(response => {
                                console.log(response)

                                this.resetAndCloseDialog()
                            })
                    }
                })
            },
            resetObjects() {
                this.login.username = '';
                this.login.password = '';
                this.registration.forename = '';
                this.registration.surname = '';
                this.registration.company = '';
                this.registration.postcode = '';
                this.registration.telephone = '';
                this.registration.email = '';
                this.registration.password = '';
                this.registration.forename = '';
                this.registration.subscribed = false;
                this.registration.invalidMessage = '';
                this.recaptchaNotComplete = true;
                this.reset.resetEmail = '';

                this.available_branches = [];

                document.getElementById('error').style.display = "none";
                document.getElementById('firstTimeUser').style.display = "none";
                document.getElementById('invalidRegister').style.display = "none";
                document.getElementById('dupRegister').style.display = "none";
            },
            resetAndCloseDialog() {

                this.resetObjects();

                console.log('logout closing')
                if (document.getElementById('loginDialogClosable') !== null) {
                    document.getElementById('loginDialogClosable').click()
                } else if (document.getElementById('closeLogin') !== null) {
                    document.getElementById('closeLogin').click()
                }

                let router = ''

                if (this.activePanel === 'forgot') {
                    router = this.$route.path
                } else if (window.sessionStorage.getItem('_routerFrom') !== null) {
                    router = window.sessionStorage.getItem('_routerFrom')

                    if (window.sessionStorage.getItem('_routerFrom') === "/directmailr" && window.sessionStorage.getItem("_passwordChangeRequired") !== null) {
                        router = '/account/reset-password'
                    }

                    if (window.sessionStorage.getItem('_routerFrom') !== "/photofixr/checkout") {
                        window.sessionStorage.removeItem('_routerFrom')
                    }
                } else if (this.returnCookie('_token') === null) {
                    console.log(this.$route);
                    router = this.$route.path
                } else if (window.sessionStorage.getItem("_passwordChangeRequired") !== null) {
                    router = '/account/reset-password'
                } else if (this.$route.path === '/') {
                    router = '/account/summary'
                } else {
                    router = this.$route.path
                }

                Router.push({
                    name: router
                }).catch(() => {})

                this.activePanel = 'login'
                console.log('_routerFrom=' + window.sessionStorage.getItem('_routerFrom'))
                window.sessionStorage.removeItem('_routerFrom')
            },
            onSubmit: function () {
                this.$refs.invisibleRecaptcha.execute()
            },
            onVerify: function (response) {
                console.log('Verify: ' + response)
                this.recaptchaNotComplete = false
            },
            onExpired: function () {
                console.log('Expired')
            },
            resetRecaptcha() {
                this.$refs.recaptcha.reset() // Direct call reset method
            },
            handleCurrentChange(val) {
                this.selected_branch = val;
            },
            createAccount(accountType, paymentMethod) {
                this.resetAndCloseDialog();
                this.activeForm = 'login';
                EventBus.$emit('createAccount', accountType, paymentMethod);
            },
        }
    };
</script>
